"use client";
import React, { ReactNode, useEffect, useRef, useState } from "react";
import "./index.scss";

interface ToggleContentProps {
  children: ReactNode;
  tagline: string;
}

const ToggleContent: React.FC<ToggleContentProps> = ({ children, tagline }) => {
  const [isVisible, setIsVisible] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);

  const toggleVisibility = () => {
    setIsVisible((prev) => !prev);
  };

  useEffect(() => {
    if (contentRef.current) {
      contentRef.current.style.height = isVisible
        ? `${contentRef.current.scrollHeight}px`
        : "0px";
    }
  }, [isVisible]);

  return (
    <div className="component content-toggle">
      <p className="tagline" onClick={toggleVisibility}>
        {tagline}
        <button className="toggle-button">{isVisible ? "▲" : "▼"}</button>
      </p>

      <div
        className={`content-wrapper ${isVisible ? "visible" : "notVisible"}`}
      >
        <div className="content" ref={contentRef}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default ToggleContent;
